import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { CommentFileIcon, FileTypes, Popover } from 'ui/components';
import FileCardPopover from './FileCardPopover';

const BlockFileCardComponent = ({ node, getPos, editor }: NodeViewProps) => {
  const { name, type, size, url, date } = node.attrs;

  function initiateDownload(url: string, fileName: string) {
    // Open the URL in a new tab
    window.open(url, '_blank');
  }

  const formatFileSize = (bytes: number) => {
    if (bytes < 1024) return bytes + ' B';
    else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    else if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + ' MB';
    else return (bytes / 1073741824).toFixed(1) + ' GB';
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const convertToInline = () => {
    const pos = getPos();
    const { tr } = editor.view.state;

    const inlineNode = editor.schema.nodes.inlineFileCard.create(node.attrs);

    // Create a new paragraph with the inline node
    const newParagraph = editor.schema.nodes.paragraph.create(null, inlineNode);

    // Replace the block node with the new paragraph
    tr.replaceWith(pos, pos + 1, newParagraph);

    editor.view.dispatch(tr);
  };

  return (
    <NodeViewWrapper data-drag-handle>
      <div className="mx-auto my-4 max-w-2xl rounded-lg border border-border bg-background shadow-sm">
        <div className="flex items-center justify-between p-4">
          <Popover>
            <Popover.Trigger asChild>
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <CommentFileIcon type={type as FileTypes} />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-gray-900">{name}</h3>
                  <p className="text-sm text-gray-500">
                    {formatFileSize(size)} • {formatDate(date)}
                  </p>
                </div>
              </div>
            </Popover.Trigger>
            <Popover.Content className="p-2">
              <FileCardPopover
                url={url}
                view="block"
                switchView={convertToInline}
              />
            </Popover.Content>
          </Popover>
        </div>
      </div>
    </NodeViewWrapper>
  );
};

export default BlockFileCardComponent;
